// import { BlocksState } from '@/types'

import type { BlockItem, NodeItem } from '@octopus-do/octopus-project-core'

export enum Actions {
  SET_PRESET_NAME = 'SET_PRESET_NAME',
  SET_FONT = 'SET_FONT',
  SET_CONTENT = 'SET_CONTENT',
  SET_BG_COLOR = 'SET_BG_COLOR',
  SET_PAGE_PREVIEW = 'SET_PAGE_PREVIEW',
  SET_TAB_INFO = 'SET_TAB_INFO',
  SET_SEARCH_ENGINE = 'SET_SEARCH_ENGINE',
  SET_BRANDING = 'SET_BRANDING',
  SET_PUBLISH_DATA = 'SET_PUBLISH_DATA',
  REMOVE_PUBLISH_DATA = 'REMOVE_PUBLISH_DATA',
}

export type InitialState = PublishData | null

export enum PublishPresets {
  DEFAULT = 'default',
  BLUEPRINT = 'blueprint',
  DARK = 'dark',
  BLUE = 'blue',
  SANDSTONE = 'sandstone',
  SLATE_GREEN = 'slateGreen',
}

export enum PublishFonts {
  DEFAULT = 'Default',
  SERIF = 'Serif',
  MONO = 'Mono',
}

export enum PublishContent {
  SHEET = 'Sheet',
  TRANSPARENT = 'Transparent',
  ISLANDS = 'Islands',
}

export enum PublishStatus {
  PUBLISHING = 'publishing',
  UPDATING = 'updating',
  PUBLISHED = 'published',
}

export type Preset = {
  bgColor: string
  name: PublishPresets
  font: PublishFonts
  content: PublishContent
}

export type TabInfo = { id: string; name: string }

export interface PublishData {
  id: string
  projectId: string
  status: PublishStatus
  createdAt: string
  updatedAt: string
  tab: TabInfo
  searchEngine: boolean
  withBranding: boolean
  pagePreview: boolean
  contentType: PublishContent
  fontType: PublishFonts
  bgColor: string
  presetName?: PublishPresets | null
  theme: string
}

export interface PublishResponse {
  id: string
  projectUuid: string
  status: PublishStatus
  createdAt: string
  updatedAt: string
  tab: TabInfo
  searchEngine: boolean
  withBranding: boolean
  pagePreview: boolean
  contentType: PublishContent
  fontType: PublishFonts
  bgColor: string
  presetName?: PublishPresets
  theme: string
}

export type PublishMenu = {
  name: string
  order: number
  items: MenuType[]
}

export type MenuType = {
  id: string
  name: string
  slug?: string
  uniqIndex?: number
  children: MenuType[]
  depth: number
}

export interface PublishNodeItem extends NodeItem {
  name: string
  uniqIndex: number
  color: string
  slug: string | null
}

export type PublishProjectRequest = {
  id?: string
  projectId: string
  tab: { id: string; name: string }
  searchEngine: boolean
  withBranding: boolean
  pagePreview: boolean
  status?: PublishStatus
  contentType: PublishContent
  fontType: PublishFonts
  bgColor: string
  presetName?: PublishPresets | null
  theme: string
  content: {
    projectName: string
    avatar: string | null
    blocks: BlockItem[]
    tree: PublishNodeItem[]
    menu: PublishMenu[]
    projectFrame: string
  }
}
